declare global {
  interface Window {
    scrolltotop?: () => void;
    scrolltoWinners?: () => void;
    newstolater?: () => void;
    pop?: () => void;
    cross?: (el: HTMLElement) => void;
    winnerFunction?: () => void;
    scrolltoConsumerFinancialSolution?: () => void;
    scrolltoEducationalTechnology?: () => void;
    scrolltoESGSolution?: () => void;
    scrolltoGeronTechnology?: () => void;
    scrolltoHealthTechnology?: () => void;
    scrolltoMarketingTechnology?: () => void;
    scrolltoPropertyTechnology?: () => void;
    scrolltoSmartBuilding?: () => void;
    scrolltoSmartMobility?: () => void;
    scrolltoSmartWorkforceManagement?: () => void;
    scrolltoWearableInternetofThingsRobotics?: () => void;
    scrolltoWeb3Metaverse?: () => void;
  }
}

const blurActiveElement = () => {
  const activeEl = document.activeElement;
  if (activeEl instanceof HTMLElement) {
    activeEl.blur();
  }
};

const smoothScrollToId = (id: string, block: ScrollLogicalPosition = 'start') => {
  const el = document.getElementById(id);
  el?.scrollIntoView({ block, behavior: 'smooth', inline: 'start' });
};

export const mount2025Runtime = () => {
  const reveal = () => {
    const reveals = document.querySelectorAll('.reveal');
    const windowHeight = window.innerHeight;

    reveals.forEach((el) => {
      const elementTop = el.getBoundingClientRect().top;
      const elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  };

  const previousOnClick = window.onclick;
  const onWindowClick = (event: MouseEvent) => {
    const target = event.target as Element | null;
    if (!target?.matches('.dropbtn')) {
      const dropdowns = document.getElementsByClassName('dropdown-content');
      for (let i = 0; i < dropdowns.length; i += 1) {
        const openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('winnershow')) {
          openDropdown.classList.remove('winnershow');
        }
      }
    }
  };

  window.scrolltotop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    blurActiveElement();
  };

  window.scrolltoWinners = () => {
    smoothScrollToId('WinnerWrapper');
    const newsAlertEl = document.getElementById('newsAlert');
    if (newsAlertEl) newsAlertEl.style.display = 'none';
    blurActiveElement();
  };

  window.newstolater = () => {
    const newsAlertEl = document.getElementById('newsAlert');
    if (newsAlertEl) newsAlertEl.style.display = 'none';
    blurActiveElement();
  };

  window.pop = () => {
    const navEl = document.getElementById('navmenulist');
    if (!navEl) return;
    navEl.style.display = navEl.style.display === 'block' ? 'none' : 'block';
  };

  window.cross = (el: HTMLElement) => {
    el.classList.toggle('change');
  };

  window.winnerFunction = () => {
    document.getElementById('winnerDropdown')?.classList.toggle('winnershow');
  };

  window.scrolltoConsumerFinancialSolution = () => smoothScrollToId('winner_categories_Consumer_Financial_Solution');
  window.scrolltoEducationalTechnology = () => smoothScrollToId('winner_categories_Educational_Technology');
  window.scrolltoESGSolution = () => smoothScrollToId('winner_categories_ESG_Solution');
  window.scrolltoGeronTechnology = () => smoothScrollToId('winner_categories_Geron_Technology');
  window.scrolltoHealthTechnology = () => smoothScrollToId('winner_categories_Health_Technology');
  window.scrolltoMarketingTechnology = () => smoothScrollToId('winner_categories_Marketing_Technology');
  window.scrolltoPropertyTechnology = () => smoothScrollToId('winner_categories_Property_Technology');
  window.scrolltoSmartBuilding = () => smoothScrollToId('winner_categories_Smart_Building');
  window.scrolltoSmartMobility = () => smoothScrollToId('winner_categories_Smart_Mobility');
  window.scrolltoSmartWorkforceManagement = () => smoothScrollToId('winner_categories_Smart_Workforce_Management');
  window.scrolltoWearableInternetofThingsRobotics = () =>
    smoothScrollToId('winner_categories_Wearable_InternetofThings_Robotics', 'end');
  window.scrolltoWeb3Metaverse = () => smoothScrollToId('winner_categories_Web3_Metaverse', 'end');

  window.addEventListener('scroll', reveal);
  window.onclick = onWindowClick;

  return () => {
    window.removeEventListener('scroll', reveal);
    if (window.onclick === onWindowClick) {
      window.onclick = previousOnClick;
    }
    delete window.scrolltotop;
    delete window.scrolltoWinners;
    delete window.newstolater;
    delete window.pop;
    delete window.cross;
    delete window.winnerFunction;
    delete window.scrolltoConsumerFinancialSolution;
    delete window.scrolltoEducationalTechnology;
    delete window.scrolltoESGSolution;
    delete window.scrolltoGeronTechnology;
    delete window.scrolltoHealthTechnology;
    delete window.scrolltoMarketingTechnology;
    delete window.scrolltoPropertyTechnology;
    delete window.scrolltoSmartBuilding;
    delete window.scrolltoSmartMobility;
    delete window.scrolltoSmartWorkforceManagement;
    delete window.scrolltoWearableInternetofThingsRobotics;
    delete window.scrolltoWeb3Metaverse;
  };
};
